import { FC } from 'react'
import { Button } from 'antd'
import { TRedirectDomain } from '../types'
import { isConnected } from '../utils'

type Props = {
 redirects: TRedirectDomain[]
 primaryDomain: string
 onAdd: () => void
 // Reopens the wizard on step 3 for a redirect still waiting on nameservers
 onViewInstructions: (domain: string) => void
 // Opens the DNS records modal for a connected redirect
 onManageRecords: (redirect: TRedirectDomain) => void
 // Opens the delete confirmation for a redirect (any status)
 onDelete: (redirect: TRedirectDomain) => void
}

const StatusPill: FC<{ redirect: TRedirectDomain }> = ({ redirect }) => {
 if (isConnected(redirect.ns_status)) {
  return (
   <span className="status-pill live">
    <i className="fas fa-check" /> Connected
   </span>
  )
 }
 if (redirect.ns_status === 'failed') {
  return (
   <span className="status-pill failed">
    <i className="fas fa-times" /> Failed
   </span>
  )
 }
 return (
  <span className="status-pill pending">
   <i className="fas fa-clock" /> Waiting
  </span>
 )
}

// Other domains the client owns that forward to the primary domain
const RedirectDomainsSection: FC<Props> = ({
 redirects,
 primaryDomain,
 onAdd,
 onViewInstructions,
 onManageRecords,
 onDelete,
}) => (
 <div className="card">
  <div className="card-head">
   <h2>Redirecting domains</h2>
  </div>
  <div className="card-body">
   <p className="sub">
    Other domains you own that should forward visitors here — for example, an
    old brand name.
   </p>
   {redirects.length ? (
    redirects.map((redirect) => (
     <div className="redirect-row" key={redirect.id}>
      <div>
       <span className="rname">{redirect.domain}</span>
       <span className="rarrow">
        → redirects to {redirect.redirects_to || primaryDomain}
       </span>
      </div>
      <div className="redirect-status">
       {redirect.ns_status === 'pending_ns' && (
        <button
         type="button"
         className="link-btn"
         onClick={() => onViewInstructions(redirect.domain)}
        >
         Setup instructions
        </button>
       )}
       {isConnected(redirect.ns_status) && (
        <button
         type="button"
         className="link-btn"
         onClick={() => onManageRecords(redirect)}
        >
         <i className="fas fa-tasks" /> Records
        </button>
       )}
       <StatusPill redirect={redirect} />
       <button
        type="button"
        className="link-btn delete-btn"
        onClick={() => onDelete(redirect)}
       >
        <i className="fas fa-trash-alt" /> Delete
       </button>
      </div>
     </div>
    ))
   ) : (
    <div className="redirect-empty">No redirecting domains yet.</div>
   )}
   <Button
    className="step-btn"
    icon={<i className="fas fa-plus" />}
    onClick={onAdd}
   >
    Add redirect domain
   </Button>
  </div>
 </div>
)

export default RedirectDomainsSection
